export const isNullOrEmpty = (value: string | null) => {
  return value === null || value === '';
}

export const isNullOrUndefined = (value: string | null | undefined) => {
  return value === null || value === undefined;
}

export const isNullOrUndefinedOrEmpty = (value: string | null | undefined) => {
  return isNullOrUndefined(value) || isNullOrEmpty(value);
};

/** Trim and title-case each word (e.g. for city names or labels). Returns "" for null/undefined/whitespace-only. */
export function toTitleCase(value: string | null | undefined): string {
  if (value == null || value.trim() === "") return "";
  return value
    .trim()
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

/** Truncate string to maxLength and append ellipsis if truncated. */
export function truncateWithEllipsis(value: string, maxLength: number): string {
  if (value.length <= maxLength) return value;
  return value.slice(0, maxLength).trimEnd() + "…";
}

/** Normalize a name for comparison by lowercasing and stripping hyphens, dots, and whitespace. */
export function normalizeName(name: string): string {
  return name.toLowerCase().replace(/[-.\s]/g, "");
}